import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';
import {CreateBulkBillToInput} from './__generated__/CreateBulkBillToMutation.graphql';
import {createRangeBulkAddUpdater} from '../../relay-helpers/RelayCacheHelpers';

const mutation = graphql`
	mutation CreateBulkBillToMutation($input: CreateBulkBillToInput!) {
		createBulkBillTo(input: $input) {
			billTos {
				node {
					id
					name
					address
					externalId
					taxId
					billFromId
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: CreateBulkBillToInput,
	onSuccess?: (response) => void,
	onError?: (error: Error) => void
): Disposable {
	trackEvent('Bill To', 'Bulk Created', input);

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation(environment, {
		mutation,
		variables,
		updater: createRangeBulkAddUpdater(
			input.billTos?.[0]?.billFromId || '',
			'createBulkBillTo',
			'billTos',
			'BillFrom_billTos'
		),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
